import React, { PropTypes } from 'react';
import { gettext } from '../../../i18n/service.js';
import VirtualDropdown from '../../virtualDropdown/';

class CountriesComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const countries = this.props.countries.map((country) => {
      return { id: country.id, name: country.name.en };
    });

    return (
      <div className="cities">
        <VirtualDropdown
          onOpen={this.props.clearCity}
          placeholder={gettext('COUNTRY')}
          elements={countries}
          onSelect={this.props.onSelect}
          defaultValue={this.props.defaultValue}
        />
      </div>
    );
  }
}

CountriesComponent.propTypes = {
  operators: PropTypes.array
};

export default CountriesComponent;



// WEBPACK FOOTER //
// ./src/components/settings/components/CountriesComponent.js